export default {
  state: {
    projects: [
      {
        id: 523,
        title: 'Музейный комплекс "Пропавшие без вести".',
        subtitle: 'Концептуальное решение 2017 г.<br>Автор идеи: Рыжков Н.И.',
        bgUrl: require('@/assets/img/img_bg-portfolio/portfolio_bg5.png'),
        link: {query: {openBlock5: true}},
        cover: require('@/assets/img/case5/pic4.jpg'),
        images: [
          require('@/assets/img/case5/pic4.jpg'),
          require('@/assets/img/case5/Case1_2.jpg'),
          require('@/assets/img/case5/Case1_3.jpg'),
        ]
      },
      {
        id: 255,
        title: 'Музей письменности. Лихудов корпус. Новгородский кремль.',
        subtitle: 'Концептуальные решения. Эскизно-технический проект экспозиции 2018 г.<br>' +
        'Авторы научной концепции: Астафьев А.В.,Десятсков К.С.',
        bgUrl: require('@/assets/img/img_bg-portfolio/portfolio_bg2.png'),
        link: {query: {openBlock2: true}},
        cover: require('@/assets/img/Pismennost.jpg'),
        images: [
          require('@/assets/img/case2/pic1.jpg'),
          require('@/assets/img/case2/pic2.jpg'),
          require('@/assets/img/case2/pic3.jpg'),
          require('@/assets/img/case2/pic4.jpg'),
          require('@/assets/img/case2/pic5.jpg')
        ]
      },
      {
        id: 367,
        title: 'Инсталляция на площади Св.Анны.',
        subtitle: 'г.Логроньо.пл. Испания.<br>Концептуальное решение 2019 г.',
        bgUrl: require('@/assets/img/img_bg-portfolio/portfolio_bg3.png'),
        testRoute: '$route.query.openBlock3',
        cover: require('@/assets/img/ANA_intallation.jpg'),
        images: [
          require('@/assets/img/case3/pic1.jpg'),
          require('@/assets/img/case3/pic2.jpg'),
          require('@/assets/img/case3/pic3.png'),
          require('@/assets/img/case3/pic4.jpg')
        ]
      },
      {
        id: 4543,
        title: 'Музей исчезающих работ.',
        subtitle: 'Арте Селла, Италия.<br>Концептуальное решение 2019 г.',
        bgUrl: require('@/assets/img/img_bg-portfolio/portfolio_bg4.png'),
        link: {query: {openBlock4: true}},
        cover: require('@/assets/img/CA_graphic.jpg'),
        images: [
          require('@/assets/img/case4/pic1.jpg'),
          require('@/assets/img/case4/pic2.png'),
          require('@/assets/img/case4/pic3.jpg'),
          require('@/assets/img/case4/pic4.jpg')
        ]
      },
      {
        id: 1878,
        title: 'Музей бронетанковой техники. Интерактивные классы.',
        subtitle: 'Белгородская область, Прохоровка.<br> Графическое оформление, дизайн мебели. ' +
          'Реализация 2017 г.',
        bgUrl: require('@/assets/img/img_bg-portfolio/portfolio_bg1.png'),
        link: {query: {openBlock1: true}},
        cover: require('@/assets/img/MBTT.jpg'),
        images: [
          require('@/assets/img/case1/pic1.jpg'),
          require('@/assets/img/case1/pic2.jpg'),
          require('@/assets/img/case1/pic3.jpg'),
          require('@/assets/img/case1/pic4.jpg'),
          require('@/assets/img/case1/pic5.jpg'),
          require('@/assets/img/case1/pic6.jpg'),
          require('@/assets/img/case1/pic7.jpg')
        ]
      }
    ]
  },
  getters: {
    projects(state) {
      return state.projects
    },
    projectById(state) {
      return function(id) {
        return state.projects.find(item => item.id === +id)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/projects.js